import { render } from "./DownloadApp.vue?vue&type=template&id=70b9948b&ts=true"
import script from "./DownloadApp.vue?vue&type=script&lang=ts"
export * from "./DownloadApp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__